"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Disconnect = exports.StandardDisconnect = void 0;
/** Name of the feature. */
exports.StandardDisconnect = 'standard:disconnect';
/**
 * @deprecated Use {@link StandardDisconnect} instead.
 *
 * @group Deprecated
 */
exports.Disconnect = exports.StandardDisconnect;
//# sourceMappingURL=disconnect.js.map